export default "__VITE_ASSET__bf61e51a__"